"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultList = exports.ListPure = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
const paper_1 = require("@clds/paper");
const style_utils_1 = require("@clds/style-utils");
const ListStyleProvider_1 = require("./ListStyleProvider");
const theme_1 = require("./theme");
const PaperWithFocusRing = (0, styled_components_1.default)(paper_1.Paper) `
  max-height: ${(0, theme_1.popoverMaxHeightVariant)((variant) => variant.maxHeight)};
  ${({ maxHeight }) => maxHeight !== undefined &&
    maxHeight !== 'none' &&
    `
        overflow: auto;
    `}
  ${(0, style_utils_1.focusRing)()}
`;
/**
 * Pure list component which provides list items container style
 */
// eslint-disable-next-line react/display-name
exports.ListPure = (0, react_1.forwardRef)((_a, ref) => {
    var { children, borderRadius, depth } = _a, rest = tslib_1.__rest(_a, ["children", "borderRadius", "depth"]);
    return (react_1.default.createElement(PaperWithFocusRing, Object.assign({ role: "list" }, rest, { borderRadius: borderRadius, depth: depth, ref: ref }), children));
});
/**
 * List component that reads variant from context
 */
// eslint-disable-next-line react/display-name
exports.DefaultList = (0, react_1.forwardRef)((props, ref) => {
    const listContext = (0, ListStyleProvider_1.useListStyle)();
    return react_1.default.createElement(exports.ListPure, Object.assign({}, listContext, props, { ref: ref }));
});
//# sourceMappingURL=List.js.map